import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const TutoringScheduleEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Schedule Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <TextInput source="tutor.id" label="Tutor ID" fullWidth />
        <TextInput source="agreement.id" label="Agreement ID" fullWidth />
        <SelectInput
          source="status"
          choices={['Draft', 'Proposed', 'Accepted', 'Rejected', 'Active', 'Completed', 'Cancelled'].map(s => ({ id: s, name: s }))}
          fullWidth
        />
      </Box>
    </SimpleForm>
  </Edit>
);
